export interface RecalProcessAndGenGenerateCriteria {

    seqNoFrom: number | null,
    seqNoTo: number | null,
    billToCompanyList: string[] | null,
    customerCodeList: string[] | null,
    consolidationMethod: string | null,
    revenueAccountCode: string | null,
    revenueCompanyCode: string | null,
    costCentreCode: string | null,
    intercompanyCode: string | null,
    productServiceCode: string | null,
    projectCode: string | null,
    salesChannelCode: string | null,
    countryCode: string | null,
    spareCode: string | null,
    desc1: string | null,
    desc2: string | null,
    docDateFrom: Date | null,
    docDateTo: Date | null,

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_RECAL_PROCESS_AND_GEN_GENERATE_CRITERIA: RecalProcessAndGenGenerateCriteria = {
    seqNoFrom: null,
    seqNoTo: null,
    billToCompanyList: [],
    customerCodeList: [],
    consolidationMethod: null,
    revenueAccountCode: null,
    revenueCompanyCode: null,
    costCentreCode: null,
    intercompanyCode: null,
    productServiceCode: null,
    projectCode: null,
    salesChannelCode: null,
    countryCode: null,
    spareCode: null,
    desc1: null,
    desc2: null,
    docDateFrom: null,
    docDateTo: null
}